export default "__VITE_ASSET__C0DH30vs__"